module.exports = __webpack_public_path__ + "img/tanlinbao.83804e51.png";